<template>
    <div class="segment-tail">

        <div class="option-buttons">

            <div id="info-items"
                 class="info-items">
                <MatchPercentage v-model="translationSegment" />
                <component :is="componentType(translationSegment)"
                           v-model="translationSegment" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { TranslationSegment } from '@/models/TranslationSegment';
    import { SegmentEditorItem } from '@/models/SegmentEditorItem';
    import { SegmentStatus } from '@/models/SegmentStatus';

    import MatchPercentage from './MatchPercentage.vue';
    import StateImage from './StateImage.vue';

    import SegmentStatusIcon from '@/components/SegmentStatusIcon.vue';

    export default defineComponent({
        props: {
            modelValue: Object,
        },
        components: {
            MatchPercentage,
            StateImage,
            SegmentStatusIcon,
        },
        data() {
            return {
            }
        },
        computed: {
            segmentItem: {
                get(): SegmentEditorItem { return this.modelValue as SegmentEditorItem; },
                set(value: SegmentEditorItem) { this.$emit('input', value); }
            },
            translationSegment: {
                get(): TranslationSegment { return this.segmentItem.data as TranslationSegment; },
                set(value: TranslationSegment) { this.segmentItem.data = value }
            },
        },
        methods: {
            componentType(translationSegment: TranslationSegment) {
                switch (translationSegment.segmentStatus) {
                    case SegmentStatus.Ok:
                    case SegmentStatus.Undefined:
                        return StateImage;
                    case SegmentStatus.SourceAndTargetReach500Limit:
                    case SegmentStatus.SourceReach500Limit:
                    case SegmentStatus.TargetReach500Limit:
                        return SegmentStatusIcon;

                    default: StateImage;
                }
            },
        }

    });
</script>

<style lang="scss" scoped>
    .segment-tail {
        margin: 15px 0 0 0;
        display: flex;
        flex-direction: column;
        width: 110px;
    }

    .option-buttons {
        display: flex;

        .info-items {
            display: flex;
        }
    }
</style>